import React from 'react';
import { NavigationRoute } from '@/lib/navigationRoutes';
import { Link } from './Link';

interface SubRouteNavItemProps {
  item: NavigationRoute;
  isOpen: boolean;
}

export const SubRouteNavItem: React.FC<SubRouteNavItemProps> = ({ item, isOpen }) => (
  <Link
    href={item.href}
    title={item.label}
    icon={item.iconName}
    disabled={item.disabled}
    isActive={item.isActiveLink}
    isBeta={item.isBeta}
    isOpen={isOpen}
  />
);
